// extracted by mini-css-extract-plugin
export default {"Main":"OptionCase_Main__cFfNp","Title":"OptionCase_Title__vHgpk"};